import React, { useState, useEffect, useRef } from "react";
import "./Chat.scss"; // Optional for styling

const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatEndRef = useRef(null);

  const handleUserInput = async () => {
    if (!userInput.trim()) return;

    const userMessage = { sender: "user", content: userInput };
    setMessages((prev) => [...prev, userMessage]);
    setUserInput("");
    setIsTyping(true);

    // Simulate an API call or streaming response
    const streamResponse = await simulateStreamResponse("This is a streaming response from the AI!");
    setMessages((prev) => [...prev, { sender: "bot", content: streamResponse }]);
    setIsTyping(false);
  };

  const simulateStreamResponse = async (fullResponse) => {
    const streamDelay = 50; // Delay between characters
    let streamedResponse = "";
    for (let i = 0; i < fullResponse.length; i++) {
      await new Promise((resolve) => setTimeout(resolve, streamDelay));
      streamedResponse += fullResponse[i];
      setMessages((prev) => [
        ...prev.slice(0, -1), // Remove the placeholder message
        { sender: "bot", content: streamedResponse },
      ]);
    }
    return streamedResponse;
  };

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            {msg.content}
          </div>
        ))}
        {isTyping && <div className="message bot">...</div>}
        <div ref={chatEndRef} />
      </div>
      <div className="input-box">
        <input
          type="text"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleUserInput()}
          placeholder="Type your message..."
        />
        <button onClick={handleUserInput}>Send</button>
      </div>
    </div>
  );
};

export default Chat;
